import React from "react";
import SectionReveal from "./SectionReveal";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative py-14 px-6 text-center"
    >
      <SectionReveal>
        <p className="font-arabic text-2xl text-champagne leading-loose">
          وَمِنْ آيَاتِهِ أَنْ خَلَقَ لَكُم مِّنْ أَنفُسِكُمْ أَزْوَاجًا
        </p>
        <p className="mt-3 font-serif italic text-sm text-ink/60 max-w-xs mx-auto leading-relaxed">
          &ldquo;And among His signs is that He created for you from yourselves
          mates that you may find tranquility in them.&rdquo;
        </p>
        <p className="mt-1 text-[10px] uppercase tracking-[0.4em] text-ink/45">
          Qur&apos;an 30:21
        </p>

        <div className="mt-10 flex items-center justify-center gap-3">
          <span className="h-px w-10 bg-champagne/40" />
          <p className="font-serif italic text-ink">Fuzail &amp; Fayeza</p>
          <span className="h-px w-10 bg-champagne/40" />
        </div>
        <p className="mt-2 text-[10px] uppercase tracking-[0.35em] text-ink/40">
          16 · 08 · 2026
        </p>
      </SectionReveal>
    </footer>
  );
}
